// src/hooks/useToast.js
import { useRef, useState } from "react";

export function useToast() {
  const [toast, setToast] = useState({ show: false, msg: "" });
  const timer = useRef(null);

  const showToast = (msg) => {
    clearTimeout(timer.current);
    setToast({ show: true, msg });
    timer.current = setTimeout(() => setToast(t => ({ ...t, show: false })), 3000);
  };

  return { toast, showToast };
}
